<template>
  <div>
    <el-dialog :visible.sync="show" title="证件到期时间" :before-close="handleClose" class="boder8 resetRegister">
      <div class="resetRegister-box">
        <div>类型</div>
        <div class="align-item mt10 mb10">
          <div v-for="item in timeTypeOptions" :key="item.id" class="timeOptions br10 cur" :class="[activeCode == item.id ? 'active':'']" @click="timeChange(item.id)">{{ item.name }}</div>
        </div>
        <div v-show="activeCode == 'custom'">到期时间</div>
        <div class="mt10" v-show="activeCode == 'custom'">
          <el-date-picker v-model="idCardValidEndTime" value-format="yyyy-MM-dd" type="date" :picker-options="beginPickerOptions" placeholder="选择日期"
            popper-class="el-date-picker" class="width200">
          </el-date-picker>
        </div>
        
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="btns">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      idCardTimeType: '',
      idCardValidEndTime: '',
      timeTypeOptions: [{ id: 'custom', name: '期限有效' }, { id: 'permanentlyValid', name: '永久有效' }],
      activeCode: 'custom'
    }
  },
  computed: {
    beginPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - (24 * 60 * 60 * 1000);
        }
      };
    }
  },
  methods: {
    open (arg) {
      console.log(arg);
      this.idCardTimeType = arg.idCardTimeType || 'custom'
      this.idCardValidEndTime = arg.idCardValidEndTime || ''
      this.activeCode = this.idCardTimeType
      this.show = true
    },
    timeChange (code) {
      this.activeCode = code
    },
    confirm () {
      if (this.activeCode == 'custom' && !this.idCardValidEndTime) {
        return this.$message.error("请选择证件到期时间")
      } else if (this.activeCode == 'permanentlyValid') {
        this.idCardValidEndTime = ''
      }
      this.$emit('change', { idCardValidEndTime: this.idCardValidEndTime, idCardTimeType: this.activeCode })
      this.show = false
    },
    handleClose () {
      this.show = false
    }
  }
}
</script>

<style scoped>
.resetRegister .resetRegister-box {
  box-sizing: border-box;
}

.inputBorder {
  border: 1px solid #efefef;
}
.timeOptions {
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #ccc;
}
.active {
  color: white;
  border-color: #1989fa;
  background-color: #1989fa;
}
</style>